import PocketBase from 'pocketbase';

const pb = new PocketBase(import.meta.env.VITE_BACKEND_HOST);
pb.autoCancellation(false) // see https://github.com/pocketbase/js-sdk#auto-cancellation
export default pb;